import HotTable from 'react-handsontable';

import BaseComponent from "../../../baseComponent";
import WidgetService from "../../../../core/services/widgetService";

export default class SpreadsheetWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.handsontableData = [
      ["", "Ford", "Volvo", "Toyota", "Honda"],
      ["2016", 10, 11, 12, 13],
      ["2017", 20, 11, 14, 13],
      ["2018", 30, 15, 12, 13]
    ];
  }

  componentDidMount() {

  }

  render() {
    return (
      <div style={{paddingTop: "35px", width: '100%', height: '100%'}}>

        <HotTable root="hot" data={this.handsontableData} colHeaders={true} rowHeaders={true} contextMenu={true} width="600" height="300" stretchH="all" />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/spreadsheet/widet.jsx